module.exports = __webpack_public_path__ + "static/media/talent_logo_ru.efbcf272.png";